import uniq from "lodash/uniq";
import { escape, addToQuery, formatTimestamp, predicate } from "views/logic/queries/QueryHelper";
import { updateQueryString } from "views/logic/slices/viewSlice";
import { selectQueryString } from "views/logic/slices/viewSelectors";
import fieldTypeFor from "views/logic/fieldtypes/FieldTypeFor";
import hasMultipleValueForActions from "views/components/visualizations/utils/hasMultipleValueForActions";
const formatNewQuery = (oldQuery, field, value, type) => {
  const predicateValue = type.type === "date" ? formatTimestamp(value) : escape(value);
  return addToQuery(oldQuery, predicate(field, predicateValue));
};
const AddToQueryHandler = ({ queryId, field, value = "", type, contexts }) => async (dispatch, getState) => {
  const oldQuery = selectQueryString(queryId)(getState());
  const valuesToAdd = uniq(
    hasMultipleValueForActions(contexts) ? contexts.valuePath.map((path) => {
      const [pathField, pathValue] = Object.entries(path)[0];
      return { field: pathField, value: pathValue, type: fieldTypeFor(field, contexts == null ? void 0 : contexts.fieldTypes) };
    }) : [{ field, value, type }]
  );
  const newQuery = valuesToAdd.reduce(
    (prev, valueToAdd) => formatNewQuery(prev, valueToAdd.field, valueToAdd.value, valueToAdd.type),
    oldQuery
  );
  return dispatch(updateQueryString(queryId, newQuery));
};
export default AddToQueryHandler;
